<app-text-input [label]="'zip' | translate | uppercase" [control]="control()" [maxLength]="maxLength()" [required]="required()" [errorKey]="'invalid_zip' | translate"></app-text-input>
